export const pinks = [
  "rgb(255, 255, 255)",
  "rgb(255, 237, 255)",
  "rgb(255, 218, 255)",
  "rgb(255, 200, 255)",
  "rgb(255, 182, 255)",
  "rgb(255, 164, 255)",
  "rgb(255, 145, 255)",
  "rgb(255, 127, 255)",
];
